import React from "react";
import styles from "./style.scss";
import SectionLoading from "components/Common/SectionLoading";

interface Props {
  title: string;
  body: string;
  updateDate: string;
  isPopupLoading: boolean;
}

const NoticePopup = ({ title, body, updateDate, isPopupLoading }: Props) => {
  return (
    <div className={styles.component}>
      <div className={styles.noticeWrapper}>
        {isPopupLoading && <SectionLoading isLoading={isPopupLoading} />}
        <div className={styles.date}>{updateDate}</div>
        <div className={styles.title}>
          <h1>{title}</h1>
        </div>
        <div className={styles.bodyContainer}>
          {body
            ? (() => {
                // テキストでnewlines/タブを除外します
                const filtered = body
                  .replaceAll("<br>", "")
                  .replaceAll("\n", "")
                  .replaceAll("\r", "")
                  .replaceAll("\t", "");

                return (
                  <div
                    className={styles.body}
                    dangerouslySetInnerHTML={{ __html: filtered }}
                  />
                );
              })()
            : null}
        </div>
      </div>
    </div>
  );
};

export default NoticePopup;
